//Readme: If any of these links are subject to change or expected to change often, please move it to configMap.json
//This is for links that never change and that we don't want to manage in the infrastructures repo.
export const AishStaticUrls: { [name: string]: string } = {
  externalFileUploader: 'https://aish-apply.alberta.ca/Application/Application.aspx',
};
